export function setLocalStorageWithTTL(key: string, value: any, ttlHours = 24) {
    const now = new Date()
    const item = {
        value,
        expiry: now.getTime() + ttlHours * 60 * 60 * 1000 // Convert hours to ms
    }
    localStorage.setItem(key, JSON.stringify(item))
}

export function getLocalStorageWithTTL(key: string) {
    const itemStr = localStorage.getItem(key)
    if (!itemStr) return null

    try {
        const item = JSON.parse(itemStr)
        const now = new Date()
        if (now.getTime() > item.expiry) {
            localStorage.removeItem(key)
            return null
        }
        return item.value
    } catch {
        return null
    }
}